"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var AXSFlexItem_1 = __importDefault(require("../../layout/AXSFlexItem"));
var AXSCounter_1 = __importDefault(require("../AXSCounter"));
var colors_1 = require("../../constants/colors");
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("../../utils");
var Label = styled_components_1.default(AXSFlexItem_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  min-height: 40px;\n  width: 100%;\n  margin: 0;\n  user-select: none;\n"], ["\n  color: ", ";\n  min-height: 40px;\n  width: 100%;\n  margin: 0;\n  user-select: none;\n"])), function (_a) {
    var labelColor = _a.labelColor, theme = _a.theme;
    return utils_1.parseThemePath(labelColor, theme, colors_1.colors.GREY_650);
});
var Container = styled_components_1.default(AXSFlex_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-color: ", ";\n  border-width: 2px;\n  border-style: solid;\n  border-radius: 6px;\n  opacity: ", ";\n"], ["\n  border-color: ",
    ";\n  border-width: 2px;\n  border-style: solid;\n  border-radius: 6px;\n  opacity: ", ";\n"])), function (_a) {
    var active = _a.active, activeBorderColor = _a.activeBorderColor, borderColor = _a.borderColor, theme = _a.theme;
    return active
        ? utils_1.parseThemePath(activeBorderColor, theme, colors_1.colors.BLUE_300)
        : utils_1.parseThemePath(borderColor, theme, colors_1.colors.GREY_350);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled ? '.3' : '1';
});
var AXSPriceCodeSelector = function (_a) {
    var defaultCount = _a.defaultCount, disabled = _a.disabled, id = _a.id, stepBy = _a.stepBy, maxCount = _a.maxCount, minCount = _a.minCount, counterColor = _a.counterColor, active = _a.active, activeBorderColor = _a.activeBorderColor, counterSize = _a.counterSize, upDownSize = _a.upDownSize, upDownColor = _a.upDownColor, className = _a.className, vertical = _a.vertical, label = _a.label, labelColor = _a.labelColor, labelSize = _a.labelSize, handleChange = _a.handleChange, counterBorderColor = _a.counterBorderColor, counterActiveColor = _a.counterActiveColor, upDownActiveColor = _a.upDownActiveColor, props = __rest(_a, ["defaultCount", "disabled", "id", "stepBy", "maxCount", "minCount", "counterColor", "active", "activeBorderColor", "counterSize", "upDownSize", "upDownColor", "className", "vertical", "label", "labelColor", "labelSize", "handleChange", "counterBorderColor", "counterActiveColor", "upDownActiveColor"]);
    return (React.createElement(Container, __assign({ active: active, activeBorderColor: activeBorderColor, alignItems: "flex-start", alignContent: "center", disabled: disabled, justifyContent: "center", className: classnames_1.default(['c-axs-price-code-selector', className]), flexDirection: !vertical ? 'row' : 'column', flexWrap: "wrap" }, props),
        React.createElement(AXSFlex_1.default, { flexWrap: "wrap", width: "100%", justifyContent: "center", alignItems: "center" },
            label &&
                React.createElement(Label, { marginTop: "16px", marginBottom: "24px", textAlign: "center", labelSize: labelSize, labelColor: labelColor }, label),
            React.createElement(AXSCounter_1.default, { active: active, disabled: disabled, stepBy: stepBy, maxCount: maxCount, minCount: minCount, counterColor: counterColor, counterBorderColor: counterBorderColor, defaultCount: defaultCount, handleChange: function (count) { return handleChange(id, count); }, counterSize: counterSize, upDownSize: upDownSize, upDownColor: upDownColor, vertical: vertical, counterActiveColor: counterActiveColor, upDownActiveColor: upDownActiveColor }))));
};
AXSPriceCodeSelector.defaultProps = {
    active: false,
    border: true,
    borderColor: 'axsui.components.priceCodeSelector.borderColor',
    borderRadius: '6px',
    borderWidth: '2px',
    counterActiveColor: 'axsui.components.priceCodeSelector.counterActiveColor',
    counterBorderColor: 'axsui.components.priceCodeSelector.counterBorderColor',
    counterColor: 'axsui.components.priceCodeSelector.counterColor',
    counterSize: 'axsui.components.priceCodeSelector.counterSize',
    defaultCount: 0,
    disabled: false,
    height: '144px',
    labelColor: 'axsui.components.priceCodeSelector.labelColor',
    labelSize: 'axsui.components.priceCodeSelector.labelSize',
    maxCount: 999,
    minCount: 0,
    stepBy: 1,
    upDownActiveColor: 'axsui.components.priceCodeSelector.upDownActiveColor',
    upDownColor: 'axsui.components.priceCodeSelector.upDownColor',
    upDownSize: 'axsui.components.priceCodeSelector.upDownSize',
    vertical: false,
    width: '165px',
};
exports.default = AXSPriceCodeSelector;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map